import { render, staticRenderFns } from "./HeroSwiper.vue?vue&type=template&id=ebd06970&"
import script from "./HeroSwiper.vue?vue&type=script&lang=js&"
export * from "./HeroSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports